<template>
  <div
    class="ts-bg-gray-200 ts-border-blue-500 ts-rounded-md ts-p-3 ts-space-y-3"
  >
    <div>
      <a-radio-group
        name="radioGroup"
        v-model="reference"
        :default-value="1"
        @change="onSwitch"
      >
        <a-radio :value="1">
          {{ $t('wholesale.quotation') }}
        </a-radio>
        <a-radio :value="2">
          {{ $t('wholesale.saleContract') }}
        </a-radio>
      </a-radio-group>
    </div>
    <a-select
      v-model="model.quotation_id"
      :options="quotationList"
      showSearch
      allowClear
      :filterOption="
        (input, option) =>
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
      "
      @change="onFindQuotation"
      class="ts-w-full"
      v-if="reference == 1"
    ></a-select>
    <a-select
      v-model="model.contract_id"
      :options="saleContractList"
      @change="onFindSaleContract"
      showSearch
      allowClear
      :filterOption="
        (input, option) =>
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
      "
      class="ts-w-full"
      v-if="reference == 2"
    ></a-select>
    <small class="ts-mt-2">{{
      $t('wholesale.createInvoiceFromQuotationOrSaleContract')
    }}</small>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'referenceNumber',
  props: ['value', 'validate'],
  data () {
    return {
      reference: 1,
      model: {}
    }
  },
  created () {
    this.model = this.value
    this.setReference()
    this.fetchQuotation()
  },
  computed: {
    ...mapState('wholesale/operation', [
      'quotations',
      'salecontracts',
      'edit_data',
      'customers'
    ]),
    quotationList () {
      return this.quotations.map(el => ({
        value: el.quotation_id,
        label: el.quotation_no
      }))
    },
    saleContractList () {
      return this.salecontracts.map(el => ({
        value: el.contract_id,
        label: el.contract_no
      }))
    }
  },
  methods: {
    ...mapActions('wholesale/operation', [
      'getQuotation',
      'getSalecontract',
      'findQuotation',
      'findSaleContract',
      'getCustomer'
    ]),
    fetchQuotation () {
      this.$emit('loading', true)
      this.getQuotation().finally(() => {
        this.$emit('loading', false)
      })
    },
    fetchSaleContract () {
      this.$emit('loading', true)
      this.getSalecontract().finally(() => {
        this.$emit('loading', false)
      })
    },
    onSwitch () {
      this.$emit('clearInput')
      if (this.reference == 1) {
        this.fetchQuotation()
      } else {
        this.fetchSaleContract()
      }
    },
    onFindQuotation (value) {
      if (value) {
        this.$emit('loading', true)
        this.findQuotation(value)
          .then(response => {
            this.setDataQuotation(response.data)
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.$emit('loading', false)
          })
      } else {
        this.$emit('clearInput')
      }
    },
    onFindSaleContract (value) {
      if (value) {
        this.$emit('loading', true)
        this.findSaleContract(value)
          .then(response => {
            this.setDataSaleContract(response.data)
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.$emit('loading', false)
          })
      } else {
        this.$emit('clearInput')
      }
    },
    setDataQuotation (data) {
      // clear product in state before push new product on change
      let credit = this.customers.find(c => c.customer_id == data.customer_id)
      this.$store.commit('wholesale/operation/SET_PRODUCT', [])
      this.model.customer_id = data.customer_id
      this.model.sub_total = data.total_exclude_vat
      this.model.vat_rate = data.vat_rate
      this.model.vat_amount = data.vat_amount
      this.model.grand_total = data.grand_total
      this.model.quotation_id = data.quotation_id
      this.model.reference_no = data.quotation_no
      this.model.amount_deposit = 0
      this.model.contract_id = null
      this.model.credit_day = credit ? credit.credit_day : 0
      this.model.product_detail = []
      data.details.forEach(el => {
        // push product to stat be able to change uom to get new price
        this.$store.commit('wholesale/operation/SET_PRODUCT', {
          uom_cat_id: el.product.uom_cat_id,
          product_id: el.product_id,
          sale_code: el.sale_code,
          uom_category: el.product.uom_category
        })

        // push to model in detail list
        this.model.product_detail.push({
          product_id: el.product_id,
          product_name_en: el.product_name_en,
          barcode: el.barcode,
          uom_id: el.uom_id,
          quantity: el.quantity,
          unit_price: el.unit_price,
          discount_type: '%',
          discount_rate: 0,
          discount_amount: 0,
          total_after_discount: 0,
          vat_rate: 0,
          vat_amount: 0,
          grand_total: _.round(el.quantity * el.unit_price, 2),
          promo_ref_promo_product_id: null,
          promo_type_id: null,
          serial_list: [],
          is_custom: false,
          has_serial: el.is_generate_unique_serial
        })
      })
    },
    async setDataSaleContract (data) {
      // clear product in state before push new product on change
      await this.findCustomer(data.customer_id)
      this.$store.commit('wholesale/operation/SET_PRODUCT', [])
      let credit = this.customers.find(c => c.customer_id == data.customer_id)
      ;(this.model.customer_id = data.customer_id),
        (this.model.sub_total = data.total_exclude_vat),
        (this.model.vat_rate = data.vat_rate),
        (this.model.vat_amount = data.vat_amount),
        (this.model.grand_total = data.grand_total),
        (this.model.quotation_id = null),
        (this.model.reference_no = data.contract_no),
        (this.model.amount_deposit = data.deposit_amount),
        (this.model.credit_day = data ? credit.credit_day : 0),
        (this.model.seller_id = data.seller_id)
      this.model.product_detail = []
      data.details.forEach(el => {
        // push product to stat be able to change uom to get new price
        this.$store.commit('wholesale/operation/SET_PRODUCT', {
          uom_cat_id: el.product.uom_cat_id,
          product_id: el.product_id,
          sale_code: el.sale_code,
          uom_category: el.product.uom_category
        })

        // push to model in detail list
        this.model.product_detail.push({
          product_id: el.product_id,
          product_name_en: el.product_name_en,
          barcode: el.barcode,
          uom_id: el.uom_id,
          quantity: el.quantity,
          unit_price: el.unit_price,
          discount_type: '%',
          discount_rate: 0,
          discount_amount: 0,
          total_after_discount: 0,
          vat_rate: 0,
          vat_amount: 0,
          grand_total: _.round(el.quantity * el.unit_price, 2),
          promo_ref_promo_product_id: null,
          promo_type_id: null,
          serial_list: [],
          is_custom: false,
          has_serial: el.is_generate_unique_serial
        })
      })
    },
    setReference () {
      if (!_.isEmpty(this.edit_data)) {
        if (this.edit_data.quotation_id) {
          this.reference = 1
        }
        if (this.edit_data.contract_id) {
          this.reference = 2
        }
      }
    }
  }
}
</script>
